import dayjs from 'dayjs';

import { AppLocale } from '@/shared/i18n';
import { formatInterfaceDate } from '@/shared/i18n/formatLocale';

const EN_DATE_TIME_FORMAT = 'dddd, D MMMM, HH:mm';

// Rendered in the browser's own timezone, so the reader is already in the frame of reference the
// time refers to — the zone suffix only added noise. HubSpot's confirmation email carries the
// authoritative zone for anyone who booked against a different one.
export const formatBookedSlot = (startsAt?: Date, locale: AppLocale = 'en'): string | undefined => {
  if (!startsAt) return undefined;
  if (locale === 'en') return dayjs(startsAt).format(EN_DATE_TIME_FORMAT);

  return formatInterfaceDate(locale, startsAt, {
    day: 'numeric',
    hour: '2-digit',
    hour12: false,
    minute: '2-digit',
    month: 'long',
    weekday: 'long',
  });
};
